import React, { useEffect, useState } from "react";
import { Formik, Field, Form } from "formik";
import { connect, useDispatch } from "react-redux";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import "react-quill/dist/quill.snow.css";
import * as Yup from "yup";
import { toast } from "react-toastify";
import "./custom-select.css";

const DEVICE_OPTIONS = [
  { value: "Desktop", label: "Desktop" },
  { value: "Laptop", label: "Laptop" },
  { value: "Monitor", label: "Monitor" },
];

const normalizeRoleName = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");

const ALLOWED_ROLE_NAMES = new Set([
  normalizeRoleName("Developer"),
  normalizeRoleName("Admin"),
  normalizeRoleName("Super Admin"),
]);

const AddMember = ({
  designationResponseData,
  designationSearch,
  rolesResponseData,
  rolesSearch,
  skillsResponseData,
  skillsSearch,
  register,
  closeModal,
  memberUpdate,
  memberEditData,
  onSuccess,
  SetOpenModal,
  open,
}) => {
  useEffect(() => {
    const fetchData = async () => {
      designationSearch();
      rolesSearch();
      skillsSearch();
    };
    fetchData();
  }, [designationSearch, rolesSearch, skillsSearch]);
  const handleClose = () => {
    setTimeout(() => {
      SetOpenModal(false);
    }, 300);
  };
  return (
    <div className="">
      {/* Background overlay */}
      <div
        className={`fixed inset-0 transition-opacity duration-300 ease-in-out ${
          open
            ? "bg-black/50 opacity-100 z-40"
            : "opacity-0 pointer-events-none"
        }`}
        onClick={handleClose}
      />

      {/* Modal content */}
      <div
        className={`fixed top-1/2 left-1/2 z-50 flex items-center justify-center h-fit w-fit 
        transform transition-all duration-300 ease-in-out
        ${
          open
            ? "opacity-100 scale-100 -translate-x-1/2 -translate-y-1/2"
            : "opacity-0 scale-95 -translate-x-1/2 -translate-y-1/2  pointer-events-none"
        }`}
      >
        <div className="bg-white border p-8 lg:p-11 rounded-3xl w-full min-w-[300px] max-w-lg relative">
          <div className="absolute right-8 cursor-pointer top-8">
            <svg
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={() => handleClose()}
            >
              <path
                d="M0.94165 11.2638L6.1613 6.15874L11.3809 11.2638M11.3809 1.05371L6.1603 6.15874L0.94165 1.05371"
                stroke="#B9B9B9"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div className="mb-8">
            <h3 className="font-title text-lg font-light text-black mb-1">
              {memberEditData && memberEditData._id
                ? "Edit Member"
                : "Add a New Member"}
            </h3>
            <span className="block text-xs lg:text-sm font-normal text-secondary-grey-200">
              Enter basic information about the new member.
            </span>
          </div>

          <Formik
            key={open ? "open" : "closed"}
            initialValues={{
              first_name: (memberEditData && memberEditData.first_name) || "",
              last_name: (memberEditData && memberEditData.last_name) || "",
              designation:
                memberEditData &&
                memberEditData.designation &&
                memberEditData.designation._id
                  ? {
                      value: memberEditData.designation._id,
                      label: memberEditData.designation.name,
                    }
                  : "",
              role:
                (memberEditData &&
                  memberEditData.roles &&
                  memberEditData.roles.length > 0 &&
                  memberEditData.roles[0] &&
                  (memberEditData.roles[0]._id || memberEditData.roles[0])) ||
                "",
              email: (memberEditData && memberEditData.email) || "",
              password: "",
              device:
                (memberEditData &&
                  (memberEditData.seat_capability ||
                    memberEditData.device ||
                    memberEditData.device_type ||
                    memberEditData.deviceType)) ||
                "",
              additionalRoles:
                (memberEditData &&
                  memberEditData.roles &&
                  memberEditData.roles
                    .filter((r) => r.type === "Additional")
                    .map((r) => r._id || r)) ||
                [],
              skills:
                (memberEditData &&
                  memberEditData.skills &&
                  memberEditData.skills.length > 0 &&
                  memberEditData.skills.map((roleitem) => {
                    return roleitem._id;
                  })) ||
                [],
            }}
            validationSchema={Yup.object().shape({
              first_name: Yup.string().required("Enter First Name"),
              last_name: Yup.string().required("Enter Last Name"),
              designation: Yup.object().required("Choose Designation"),
              role: Yup.string().required("Choose Role"),
              email: Yup.string()
                .email("Must be a valid email")
                .max(255)
                .required("Email is required"),
              device: Yup.string().required("Choose Device"),
              password:
                memberEditData && memberEditData._id
                  ? null
                  : Yup.string().required("Enter Password"),
              skills: Yup.array().min(1, "Choose Skills"),
            })}
            onSubmit={async (values, { resetForm }) => {
              const { role, additionalRoles, designation, ...rest } = values;
              const submissionValues = {
                ...rest,
                designation: designation.value,
                device: rest.device || "",
                seat_capability: rest.device || "",
                roles: [...(role ? [role] : []), ...(additionalRoles || [])],
              };
              if (memberEditData && memberEditData._id) {
                await memberUpdate({ ...submissionValues, user_id: memberEditData._id })
                  .then((response) => {
                    if (response.message && response.message.length > 0) {
                      toast.success(response.message);
                    }
                    if (response.success) {
                      onSuccess();
                      closeModal(true);
                    }
                  })
                  .catch((response) => {
                    if (response.error && response.error.length > 0) {
                      toast.error(response.error);
                    }
                  });
              } else {
                await register(submissionValues)
                  .then((response) => {
                    if (response.message && response.message.length > 0) {
                      toast.success(response.message);
                    }
                    if (response.status === 200) {
                      onSuccess();
                      closeModal(true);
                    }
                  })
                  .catch((response) => {
                    if (response.error && response.error.length > 0) {
                      toast.error(response.error);
                    }
                  });
              }
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <Form onSubmit={handleSubmit} className="w-full">
                <div className="mb-3 relative grid grid-cols-2 gap-4">
                  <div>
                    <Field
                      className="appearance-none focus:outline-none focus:border-[#E5EAEF] transition delay-150 duration-150 ease-linear text-sm border rounded-md py-2 px-4  w-full placeholder-[#909090] text-secondary-grey-500 font-normal border-[#E5EAEF]"
                      placeholder="First Name"
                      type="text"
                      name="first_name"
                      onChange={handleChange}
                      value={values.first_name}
                    />
                    {errors.first_name && touched.first_name && (
                      <span className="text-red-500 text-xs">
                        {errors.first_name}
                      </span>
                    )}
                  </div>
                  <div className="relative">
                    <Field
                      className="appearance-none focus:outline-none focus:border-[#E5EAEF] transition delay-150 duration-150 ease-linear text-sm border rounded-md py-2 px-4  w-full placeholder-[#909090] text-secondary-grey-500 font-normal border-[#E5EAEF]"
                      placeholder="Last Name"
                      type="text"
                      name="last_name"
                    />
                    {errors.last_name && touched.last_name && (
                      <span className="text-red-500 text-xs">
                        {errors.last_name}
                      </span>
                    )}
                  </div>
                </div>

                <div className="mb-3 relative">
                  <Select
                    className="custom-search-create custom-search-select appearance-none focus:outline-none focus:border-[#E5EAEF] transition delay-150 duration-150 ease-linear text-sm border rounded-md w-full placeholder-[#909090] text-secondary-grey-300 font-normal border-[#E5EAEF] "
                    name="designation"
                    defaultValue={
                      memberEditData && memberEditData.designation
                        ? {
                            value: memberEditData.designation._id,
                            label: memberEditData.designation.name,
                          }
                        : ""
                    }
                    //isMulti
                    isSearchable={true}
                    classNamePrefix="dropdownSelect"
                    isClearable={true}
                    options={designationResponseData.map((project) => ({
                      label: project.name,
                      value: project._id,
                    }))}
                    placeholder="Designation"
                    onChange={(e) => {
                      if (e) {
                        setFieldValue("designation", e);
                      } else {
                        setFieldValue("designation", "");
                      }
                    }}
                  />
                  {errors.designation && touched.designation && (
                    <span className="text-red-500 text-xs">
                      {errors.designation}
                    </span>
                  )}
                </div>

                <div className="mb-3 relative">
                  <Select
                    className="custom-search-create custom-search-select appearance-none focus:outline-none focus:border-[#E5EAEF] transition delay-150 duration-150 ease-linear text-sm border rounded-md w-full placeholder-[#909090] text-secondary-grey-300 font-normal border-[#E5EAEF] "
                    name="device"
                    defaultValue={
                      (memberEditData &&
                        (memberEditData.seat_capability ||
                          memberEditData.device ||
                          memberEditData.device_type ||
                          memberEditData.deviceType)) ||
                      values.device
                        ? {
                            value:
                              memberEditData?.seat_capability ||
                              memberEditData?.device ||
                              memberEditData?.device_type ||
                              memberEditData?.deviceType ||
                              values.device,
                            label:
                              memberEditData?.seat_capability ||
                              memberEditData?.device ||
                              memberEditData?.device_type ||
                              memberEditData?.deviceType ||
                              values.device,
                          }
                        : ""
                    }
                    isSearchable={false}
                    classNamePrefix="dropdownSelect"
                    isClearable={true}
                    options={DEVICE_OPTIONS}
                    placeholder="Device"
                    onChange={(e) => {
                      if (e) {
                        setFieldValue("device", e.value);
                      } else {
                        setFieldValue("device", "");
                      }
                    }}
                  />
                  <span className="text-[11px] text-slate-400 mt-1 block">
                    Select the primary device for this member.
                  </span>
                  {errors.device && touched.device && (
                    <span className="text-red-500 text-xs">
                      {errors.device}
                    </span>
                  )}
                </div>

                <div className="mb-3 relative">
                  <Select
                    className="w-full text-sm font-normal"
                    classNamePrefix="react-select"
                    placeholder="Role"
                    name="role"
                    defaultValue={
                      values.role
                        ? {
                            value: values.role,
                            label:
                              rolesResponseData.find((item) => item._id === values.role)
                                ?.name || values.role,
                          }
                        : memberEditData?.roles?.[0]
                          ? {
                              value:
                                memberEditData.roles[0]._id || memberEditData.roles[0],
                              label:
                                memberEditData.roles[0].name ||
                                memberEditData.roles[0]._id ||
                                memberEditData.roles[0],
                            }
                          : null
                    }
                    options={rolesResponseData
                      .filter((item) => ALLOWED_ROLE_NAMES.has(normalizeRoleName(item.name)))
                      .map((project) => ({
                        label: project.name,
                        value: project._id,
                      }))}
                    isClearable={true}
                    isSearchable={false}
                    onChange={(e) => setFieldValue("role", e ? e.value : "")}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        minHeight: "40px",
                        borderRadius: "0.375rem", // rounded-md
                        borderColor: state.isFocused ? "#E5EAEF" : "#E5EAEF", // blue-800 or gray-300
                        boxShadow: state.isFocused
                          ? "0 0 0 1px #E5EAEF"
                          : "none",
                        "&:hover": { borderColor: "#E5EAEF" },
                        flexWrap: "wrap",
                        padding: "",
                        fontSize: "0.875rem",
                      }),
                      placeholder: (base) => ({
                        ...base,
                        color: "#909090", // gray-400
                        fontWeight: "400",
                      }),
                    }}
                  />
                  {errors.role && touched.role && (
                    <span className="text-red-500 text-xs">{errors.role}</span>
                  )}
                </div>

                {memberEditData && memberEditData._id && (
                  <div className="mb-3 relative">
                    <Select
                      className="w-full text-sm font-normal"
                      classNamePrefix="react-select"
                      placeholder="Additional Permission"
                      isMulti
                      name="additionalRoles"
                      defaultValue={
                        memberEditData?.roles
                          ?.filter((roleitem) => roleitem.type === "Additional")
                          ?.map((roleitem) => ({
                            value: roleitem._id,
                            label: roleitem.name,
                          })) || []
                      }
                      options={rolesResponseData
                        .filter((item) => item.name !== "Super admin" && item.type === "Additional")
                        .map((project) => ({
                          label: project.name,
                          value: project._id,
                        }))}
                      onChange={(e) =>
                        setFieldValue(
                          "additionalRoles",
                          e.map((rol) => rol.value)
                        )
                      }
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          minHeight: "40px",
                          borderRadius: "0.375rem",
                          borderColor: state.isFocused ? "#E5EAEF" : "#E5EAEF",
                          boxShadow: state.isFocused
                            ? "0 0 0 1px #E5EAEF"
                            : "none",
                          "&:hover": { borderColor: "#E5EAEF" },
                          flexWrap: "wrap",
                          padding: "",
                          fontSize: "0.875rem",
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          flexWrap: "wrap",
                          gap: "4px",
                          padding: "0.25rem 0.5rem",
                        }),
                        multiValue: (base) => ({
                          ...base,
                          backgroundColor: "#E0F2FE",
                          borderRadius: "0.25rem",
                          padding: "0 0.25rem",
                          margin: "2px",
                        }),
                        multiValueLabel: (base) => ({
                          ...base,
                          color: "#1E3A8A",
                          fontSize: "0.75rem",
                          whiteSpace: "normal",
                        }),
                        multiValueRemove: (base) => ({
                          ...base,
                          color: "#1E3A8A",
                          ":hover": {
                            backgroundColor: "#1D4ED8",
                            color: "white",
                          },
                        }),
                        placeholder: (base) => ({
                          ...base,
                          color: "#909090",
                          fontWeight: "400",
                        }),
                      }}
                    />
                    {errors.additionalRoles && touched.additionalRoles && (
                      <span className="text-red-500 text-xs">{errors.additionalRoles}</span>
                    )}
                  </div>
                )}

                <div className="mb-3 relative">
                  <Field
                    className="appearance-none focus:outline-none focus:border-[#E5EAEF] transition delay-150 duration-150 ease-linear text-sm border rounded-md py-2 px-4  w-full placeholder-[#909090] text-secondary-grey-500 font-normal border-[#E5EAEF]"
                    placeholder="Login Email"
                    type="text"
                    name="email"
                    autoComplete="off"
                  />
                  {errors.email && touched.email && (
                    <span className="text-red-500 text-xs">{errors.email}</span>
                  )}
                </div>

                {!(memberEditData && memberEditData._id) ? (
                  <div className="mb-3 relative">
                    <Field
                      className="appearance-none focus:outline-none focus:border-primary-navyBlue transition delay-150 duration-150 ease-linear text-sm border rounded-md py-2 px-4  w-full placeholder-[#909090] text-secondary-grey-300 font-normal border-[#E5EAEF]"
                      placeholder="Password"
                      type="password"
                      name="password"
                    />
                    {errors.password && touched.password && (
                      <span className="text-red-500 text-xs">
                        {errors.password}
                      </span>
                    )}
                  </div>
                ) : null}

                <div className=" mb-8 relative">
                  <div className="mb-8 relative">
                    <Select
                      className="w-full text-sm font-normal"
                      classNamePrefix="react-select"
                      isMulti
                      placeholder="Skills"
                      name="skills"
                      defaultValue={
                        memberEditData?.skills?.map((skill) => ({
                          value: skill._id,
                          label: skill.name,
                        })) || []
                      }
                      options={skillsResponseData.map((skill) => ({
                        label: skill.name,
                        value: skill._id,
                      }))}
                      onChange={(e) =>
                        setFieldValue(
                          "skills",
                          e.map((sk) => sk.value)
                        )
                      }
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: "40px",
                          borderRadius: "0.375rem", // Tailwind rounded-md
                          borderColor: "#E5EAEF", // Tailwind border-gray-300
                          flexWrap: "wrap",
                          paddingLeft: "5px",
                          "&:hover": {
                            borderColor: "#1E40AF", // Tailwind blue-800
                          },
                        }),
                        multiValue: (base) => ({
                          ...base,
                          backgroundColor: "#D1FAE5", // Tailwind green-100
                          borderRadius: "0.25rem", // rounded
                          padding: "0 0.25rem",
                          margin: "2px 2px 2px 0",
                        }),
                        multiValueLabel: (base) => ({
                          ...base,
                          color: "#047857", // Tailwind green-700
                          fontSize: "0.75rem",
                          whiteSpace: "normal",
                        }),
                        multiValueRemove: (base) => ({
                          ...base,
                          color: "#047857",
                          ":hover": {
                            backgroundColor: "#059669", // Tailwind green-500
                            color: "white",
                          },
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          flexWrap: "wrap", // wrap selected items
                          padding: "0.25rem 0.5rem",
                        }),
                      }}
                    />
                    {errors.skills && touched.skills && (
                      <span className="text-red-500 text-xs absolute -bottom-5 left-0">
                        {errors.skills}
                      </span>
                    )}
                  </div>
                </div>
                <div className="w-full flex items-center justify-between pt-3">
                  <button
                    onClick={() => {
                      SetOpenModal(false);
                    }}
                    className="text-black border rounded-md text-sm font-normal bg-white hover:bg-gray-200 px-4 lg:px-10 py-2 cursor-pointer"
                  >
                    Cancel
                  </button>
                  <button
                    disabled={isSubmitting}
                    className="text-white text-sm font-semibold bg-[#057D54] hover:bg-green-800 px-8 lg:px-14 py-2 rounded-md border"
                  >
                    Set
                  </button>
                </div>

                {/* <button
                  disabled={isSubmitting}
                  type="submit"
                  className="w-full p-4 bg-primary-navyBlue hover:bg-opacity-75 transition delay-150 duration-150 ease-linear text-white rounded-md text-sm font-semibold font-title"
                >
                  Save
                </button> */}
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

const mapState = (state) => ({
  designationResponseData: state.projects.designation,
  rolesResponseData: state.projects.roles,
  skillsResponseData: state.projects.skills,
});

const mapDispatch = (dispatch) => ({
  designationSearch: dispatch.projects.designationSearch,
  rolesSearch: dispatch.projects.rolesSearch,
  skillsSearch: dispatch.projects.skillsSearch,
  register: dispatch.projects.register,
  memberUpdate: dispatch.people.memberUpdate,
});

export default connect(mapState, mapDispatch)(AddMember);
